import { MDBContainer, MDBCol, MDBRow } from "mdbreact";
import React from "react";
import "./RFQ.scss";
import constants from "../common/restService/constant";
import GatewayGet from "../common/restService/GatewayGet";
import RFQMaterialGrid from "./RFQMaterialGrid";
import RFQQuotationGrid from "./RFQQuotationGrid";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import $ from "jquery";
import BlockUi from '@availity/block-ui';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {Circles} from "react-loader-spinner";
// import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import InvoiceBidDetails from "../InvoiceBidDetails/InvoiceBidDetails";
import * as XLSX from "xlsx";
class RFQRequestDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: 0,
      requestDetails: [],
      quoteDetails: [],
      transportationMode: [],
      serviceType: [],
      serviceCode: [],
      srvCode: [],
      quotationData: [],
      visible: false,
      rejectedReasonCode: [],
      selectedRejectedReasonCode: { text: "Select Reason", value: "" },
      totalProductArray: [],
      totalMaterialArray: [],
      //
      ReqPickupDate: "",
      ReqDeliveryDate: "",
      vendor_id: "",
      selectedQuoteData: {},
      childGrid :[],
      materialgridData :[],
      totalChargableWeight : "",
      documentTypeArr :[],
      
      ShipFromTimeZone: "",
      ShipToTimeZone: "",
      invoiceInputs: {
        childSCAC: '',
        hawbNumber: '',
        proNumber: ''
      }
    };
    this.getQuotationData = this.getQuotationData.bind(this);
  }

  getServiceCodeText(value) {
    for (var i = 0; i < this.state.serviceCode.length; i++) {
      if (this.state.serviceCode[i].value == value) {
        return this.state.serviceCode[i].text;
      }
    }
  }

  getServiceTypeText(value) {
    for (var i = 0; i < this.state.serviceType.length; i++) {
      if (this.state.serviceType[i].value == value) {
        return this.state.serviceType[i].text;
      }
    }
  }

  getTransporatationModeText(value) {
    for (var i = 0; i < this.state.transportationMode.length; i++) {
      if (this.state.transportationMode[i].value == value) {
        return this.state.transportationMode[i].text;
      }
    }

    // var data = this.state.transportationMode.filter(data => this.state.transportationMode[i].value == value)
    // return data;
  }

  async getRequestDetails(input) {
    let props = {};
    let inputObj = {};
    let InputJSONString = "";
    props["query"] = constants.serviceRoot;
    props["headers"] = constants.serviceHeaders;
    InputJSONString = JSON.stringify(input);
    inputObj["Activity"] = "FO_DISPLAY_MB";
    inputObj["Input"] = InputJSONString;
    props.input = inputObj;

    const result = await GatewayGet(props, props.input);
    if (result.STATUS == "SUCCESS") {
      this.setState({ itemData: result.EX_ITEM });
      this.state.items = result.EX_ITEM;
      var Address = result.EX_ADDRESS;
      var attributes = result.EX_ATTRIBUTES;
      var bp = result.EX_BP;
      var docRef = result?.EX_DOCREF;
      var header = result.EX_HEADER;
      var item = result.EX_ITEM;
      var notes = result.EX_NOTES;
      var brokerEmail = "";
      var brokerName = "";
      var brokerPhNo = "";
      var specialInst = "";
      var IntelRefNo = "";
      var hawbNumber = "";
      var proNumber = "";

      
      for (let i = 0; i < notes.length; i++) {
        if (notes[i].TEXT_TYPE == "ZBRE") {
          brokerEmail = notes[i].TEXT;
        } else if (notes[i].TEXT_TYPE == "ZBRN") {
          brokerName = notes[i].TEXT;
        } else if (notes[i].TEXT_TYPE == "ZBRP") {
          brokerPhNo = notes[i].TEXT;
        } else if (notes[i].TEXT_TYPE == "ZSIR") {
          specialInst = notes[i].TEXT;
        }
      }

      if (docRef !== undefined) { 
        for (let i = 0; i < docRef.length; i++)  {
          if (docRef[i].BTD_TCO == "T54") {
            hawbNumber = docRef[i].BTD_ID;
          }

          if (docRef[i].BTD_TCO == "004") {
            proNumber = docRef[i].BTD_ID;
          }
        }
      }

      var docRefObj = {};
      var docTypeText = "";

      if (docRef !== undefined) {
        if(docRef != undefined && docRef != null) {
          // check for Doc Ref Array
          for(var i=0; i<docRef.length; i++){
            if (docRef[i].BTD_TCO != undefined && docRef[i].BTD_TCO != null) {
              if(docRef[i].BTD_TCO == "614"){
                this.state.oldFreightOrderNumber = docRef[i].BTD_ID;
              }
            }

            if (docRef[i].BTD_ID != undefined && docRef[i].BTD_ID != null) {
              // Check if the BTD_ID is present in DOCUMENT TYPE LIST
              for(var j=0; j<this.state.documentTypeArr.length; j++){
                if(docRef[i].BTD_TCO == this.state.documentTypeArr[j].value){
                  docRefObj["docType"] = docRef[i].BTD_TCO;
                  docRefObj["intelLineReferenceNumber"] = docRef[i].BTDITEM_ID;
                  if(docRefObj["intelReferenceNumber"] != undefined && docRefObj["intelReferenceNumber"] != null && docRefObj["intelReferenceNumber"] != ""){
                    docRefObj["intelReferenceNumber"] = docRefObj["intelReferenceNumber"] + "," + docRef[i].BTD_ID;
                  }
                  else{
                    docRefObj["intelReferenceNumber"] = docRef[i].BTD_ID;
                  }
                }
              }
            }
          }
        }
      }

      if(docRefObj != undefined && docRefObj != null) {
       

        for(var i=0; i<this.state.documentTypeArr.length;i++){
          if(this.state.documentTypeArr[i].value == docRefObj["docType"]){
            docTypeText = this.state.documentTypeArr[i].text;
          }
        }
      }

       
      for (var i = 0; i < attributes.length; i++) {
        if (attributes[i].NAME == "SOURCE_LOCATION_TIMEZONE") {
          let fromTimeZone =attributes[i].VALUE;
          this.setState({ ShipFromTimeZone: fromTimeZone });
        }
  
        if (attributes[i].NAME == "DEST_LOCATION_TIMEZONE") {
          let ToTimeZone =attributes[i].VALUE;
          this.setState({ ShipToTimeZone: ToTimeZone });
        }        
      };



      this.setState({
        tendmgr: header.TEND_MANAGER,
        currency: header.TEND_CURRENCY,
        IntelRefNo: docRefObj.intelReferenceNumber,
        docType: docTypeText,
        tpt: header.YTPT,
        brokerName: brokerName,
        transMode: this.getTransporatationModeText(header.TRMODCOD),
        brokerPhoneNo: brokerPhNo,
        srvCode: this.getServiceCodeText(header.YMOV_TYPE),
        brokerEmail: brokerEmail,
        commType: this.getServiceTypeText(header.YCCODE),
        specialInst: specialInst,
        Incoterms: header.INC_CLASS_CODE,
        IncoLoc: header.INC_TRANSF_LOC_N,
        //
        ReqPickupDate: header.PLANNED_SHIPMENT_START,
        ReqDeliveryDate: header.PLANNED_SHIPMENT_END,
        vendor_id: header.TSPID,
        rfq_multibid_currency: header.TEND_CURRENCY,
        invoiceInputs: {
          childSCAC: header["TSPEXEC_SCAC"],
          hawbNumber: hawbNumber,
          proNumber: proNumber,
        },
      
      });

      console.log(this.state.transMode);
      console.log(this.state.serviceCode);
      this.setState({blocking : false});
    }
  }

  async getTransportationMode() {
    let props = {};
    let inputObj = {};
    props["query"] = constants.serviceRoot;
    props["headers"] = constants.serviceHeaders;
    inputObj["Activity"] = "F4_TRANSPORTATION_MODE";
    inputObj["Input"] = "";
    props.input = inputObj;

    const result = await GatewayGet(props, props.input);
    this.setState({ transportationMode: result });
  }

  async getServiceType() {
    let props = {};
    let inputObj = {};
    props["query"] = constants.serviceRoot;
    props["headers"] = constants.serviceHeaders;
    inputObj["Activity"] = "F4_SERVICE_TYPE";
    inputObj["Input"] = "";
    props.input = inputObj;

    const result = await GatewayGet(props, props.input);
    this.setState({ serviceType: result });
  }

  async getServiceCode() {
    let props = {};
    let inputObj = {};
    props["query"] = constants.serviceRoot;
    props["headers"] = constants.serviceHeaders;
    inputObj["Activity"] = "F4_SERVICE_CODE";
    inputObj["Input"] = "";
    props.input = inputObj;

    const result = await GatewayGet(props, props.input);
    this.setState({ serviceCode: result });
  }

  async getQuotationDetails(input) {
    var isQuotationAvailable = false;
    let props = {};
    let inputObj = {};
    let InputJSONString = "";
    props["query"] = constants.serviceRoot;
    props["headers"] = constants.serviceHeaders;
    InputJSONString = JSON.stringify(input);
    inputObj["Activity"] = "Q_DISPLAY_QUOTATION";
    inputObj["Input"] = InputJSONString;
    props.input = inputObj;

    const result = await GatewayGet(props, props.input);
    if (result.status == "SUCCESS") {
      this.setState({ quotationData: result.outputData });
      if (result.outputData != undefined) {
        isQuotationAvailable = true;
        this.setState({ QuotationAvailable: isQuotationAvailable });
      }
    }
    // this.setState({ blocking: false });
  }

  // createQuotation() {
  //     this.props.history.push({
  //         pathname:"/Bid",

  //        });
  // }

  createInvoice() {

    var awardedQuotationNumber = "";
			for(var i=0; i<this.state.quotationData.length;i++){
				if(this.state.quotationData[i].awardStatus == "AW" || this.state.quotationData[i].awardStatusDesc == "Awarded"){
					awardedQuotationNumber = this.state.quotationData[i].quoteNum;
				}
			}
    this.props.onAcceptNcreateQuotationClicked({
      ReqPickupDate: this.state.ReqPickupDate,
      ReqDeliveryDate: this.state.ReqDeliveryDate,
      tor_id: this.props.data.foNum,
      rfq_no: this.state?.rfqNum,
      rfq_multibid_currency: this.state?.rfq_multibid_currency,
      buttonType: "create Invoice",
      vendor_id: this.state?.vendor_id,
      quotationNum:Number(awardedQuotationNumber),
       
      timeFromZone: this.state.ShipFromTimeZone,
      timeToZone: this.state.ShipToTimeZone,
    });

  }

  editInvoice() {

    let quoteNum = null;
    if (this.state.quotationData.length > 0) {
      if (this.state.quotationData.findIndex((data) => data['awardStatus'] === "AW") >= 0) {
        quoteNum = this.state.quotationData.find((data) => data['awardStatus'] === "AW")['quoteNum'];
      }
    }
    
    this.props.onAcceptNcreateQuotationClicked({
      ReqPickupDate: this.state.ReqPickupDate,
      ReqDeliveryDate: this.state.ReqDeliveryDate,
      tor_id: this.props.data.foNum,
      rfq_no: this.state?.rfqNum,
      rfq_multibid_currency: this.state?.rfq_multibid_currency,
      buttonType: "edit Invoice",
      invoiceInputs: this.state?.invoiceInputs,
      vendor_id: this.state?.vendor_id,
      timeFromZone: this.state.ShipFromTimeZone,
      timeToZone: this.state.ShipToTimeZone,
      quotationNum: quoteNum ? Number(quoteNum) : " "
    });
  }

  viewInvoice() {
    this.props.onAcceptNcreateQuotationClicked({
      ReqPickupDate: this.state.ReqPickupDate,
      ReqDeliveryDate: this.state.ReqDeliveryDate,
      tor_id: this.props.data.foNum,
      rfq_no: this.state?.rfqNum,
      rfq_multibid_currency: this.state?.rfq_multibid_currency,
      buttonType: "view Invoice",
      invoiceInputs: this.state?.invoiceInputs,
      vendor_id: this.state?.vendor_id,
       
      timeFromZone: this.state.ShipFromTimeZone,
      timeToZone: this.state.ShipToTimeZone,
    });
  }

  copyQuotation() {
    this.props.onAcceptNcreateQuotationClicked({
      ReqPickupDate: this.state.ReqPickupDate,
      ReqDeliveryDate: this.state.ReqDeliveryDate,
      tor_id: this.props.data.foNum,
      rfq_no: this.state?.rfqNum,
      rfq_multibid_currency: this.state?.rfq_multibid_currency,
      buttonType: "copy Quotation",
      quotationNum: this.state.selectedQuoteData?.quoteNum ? Number(this.state.selectedQuoteData?.quoteNum) : -1,
       
      timeFromZone: this.state.ShipFromTimeZone,
      timeToZone: this.state.ShipToTimeZone,
    });
  }

  rejectRFQ() {
    $("#myModal").show();
  }

  viewQuotation() {}

  exportToExcel() {
    if (this.state.itemData != undefined && this.state.itemData != null) {
      for (var i = 0; i < this.state.itemData.length; i++) {
        if (
          this.state.itemData[i].PACKAGE_TCO != undefined &&
          this.state.itemData[i].PACKAGE_TCO != ""
        ) {
          if (
            this.state.itemData[i].GRO_WEI_VAL != undefined &&
            this.state.itemData[i].GRO_WEI_VAL != null
          ) {
            if (
              this.state.itemData[i].DIM_WEI_VAL != undefined &&
              this.state.itemData[i].DIM_WEI_VAL != null
            ) {
              if (
                this.state.itemData[i].GRO_WEI_VAL >
                this.state.itemData[i].DIM_WEI_VAL
              )
                this.state.itemData[i].chargableWeight =
                  this.state.itemData[i].GRO_WEI_VAL;
              else
                this.state.itemData[i].chargableWeight =
                  this.state.itemData[i].DIM_WEI_VAL;
            } else {
              this.state.itemData[i].chargableWeight =
                this.state.itemData[i].GRO_WEI_VAL;
            }
          } else {
            if (
              this.state.itemData[i].DIM_WEI_VAL != undefined &&
              this.state.itemData[i].DIM_WEI_VAL != null
            ) {
              this.state.itemData[i].chargableWeight =
                this.state.itemData[i].DIM_WEI_VAL;
            } else {
              this.state.itemData[i].chargableWeight = 0;
            }
          }

          this.state.totalChargableWeight = this.state.totalChargableWeight + this.state.items[i].chargableWeight;
          this.state.materialgridData.push(this.state.itemData[i]);
          // Push to Total Array for Export
          this.state.items[i].rfqNum = this.state.rfqNum;
          this.state.totalProductArray.push(this.state.items[i]);
        } else {
          // vm.childGridArr.push(vm.items[i]);
          this.state.childGrid.push(this.state.itemData[i]);
          // // Push to Total Array for Export
          this.state.items[i].rfqNum = this.state.rfqNum;
          this.state.totalMaterialArray.push(this.state.items[i]);
        }
      }
    }

    this.excelExport(
      this.props.data,
      this.state.totalProductArray,
      this.state.totalMaterialArray,
      this.state.quotationData
    );
  }

  getQuotationData(data) {
    console.log(data);
    this.setState({ selectedQuoteData: data });
  }

  excelExport(dataItem, totalProductArray, totalMaterialArray, quotationArray) {
    if (
      dataItem.intelReferenceNumber != undefined &&
      dataItem.intelReferenceNumber != null &&
      dataItem.intelReferenceNumber != ""
    ) {
      dataItem.intelReferenceNumber = dataItem.intelReferenceNumber.replace(
        /,|_/g,
        ";"
      );
    }

    var weightValue = parseFloat(this.state.totalChargableWeight).toFixed(2);

    var tab_text = "<table border='2px'>";
    var textRange;
    var j = 0;

    tab_text =
      tab_text +
      "<tr><th bgcolor='#00b0f0' style='color:#FFFFFF'>RFQ Status</th><th bgcolor='#00b0f0' style='color:#FFFFFF'>RFQ Number</th><th bgcolor='#00b0f0' style='color:#FFFFFF'>Quotation Due Date</th><th bgcolor='#00b0f0' style='color:#FFFFFF'>Request ID</th><th bgcolor='#00b0f0' style='color:#FFFFFF'>Request Status</th><th bgcolor='#00b0f0' style='color:#FFFFFF'>Ship From</th><th bgcolor='#00b0f0' style='color:#FFFFFF'>Ship To</th><th bgcolor='#00b0f0' style='color:#FFFFFF'>Requested Pickup Date</th><th bgcolor='#00b0f0' style='color:#FFFFFF'>Requested Delivery Date</th></tr>";
    tab_text =
      tab_text +
      "<tr><td>" +
      (dataItem.statusName != undefined && dataItem.statusName != null
        ? dataItem.statusName
        : "") +
      "</td><td>" +
      (dataItem.rfqNum != undefined && dataItem.rfqNum != null
        ? dataItem.rfqNum
        : "") +
      "</td><td>" +
      (dataItem.rfqDuedate != undefined && dataItem.rfqDuedate != null
        ? dataItem.rfqDuedate
        : "") +
      "</td><td>" +
      (dataItem.foNum != undefined && dataItem.foNum != null
        ? dataItem.foNum
        : "") +
      "</td><td>" +
      (dataItem.freightOrderDisplayStatus != undefined &&
      dataItem.freightOrderDisplayStatus != null
        ? dataItem.freightOrderDisplayStatus
        : "") +
      "</td><td>" +
      (dataItem.sourceLocation != undefined && dataItem.sourceLocation != null
        ? dataItem.sourceLocation
        : "") +
      "</td><td>" +
      (dataItem.destinationLocation != undefined &&
      dataItem.destinationLocation != null
        ? dataItem.destinationLocation
        : "") +
      "</td><td>" +
      (dataItem.srcStopDatetime != undefined && dataItem.srcStopDatetime != null
        ? dataItem.srcStopDatetime
        : "") +
      "</td><td>" +
      (dataItem.destStopDatetime != undefined &&
      dataItem.destStopDatetime != null
        ? dataItem.destStopDatetime
        : "") +
      "</td></tr></table>";
    tab_text = tab_text + "<table><tr><td></td></tr></table>";
    tab_text =
      tab_text +
      "<table border='2px'><tr><th bgcolor='#305486' style='color:#FFFFFF'>RFQ Details </th></tr></table>";
    tab_text =
      tab_text +
      "<table border='2px'><tr><td rowspan='3'></td><td><b>Tendering Manager</b></td><td>" +
      (dataItem.tenderingManager != undefined && dataItem.tenderingManager != null
        ? dataItem.tenderingManager
        : "") +
      "</td><td rowspan='3'></td><td><b>Currency</b></td><td>" +
      (dataItem.currency != undefined && dataItem.currency != null
        ? dataItem.currency
        : "") +
      "</td></tr>";
    tab_text =
      tab_text +
      "<tr><td><b>Intel Reference Number (PO,ISM,DN)</b></td><td>" +
      (dataItem.intelReferenceNumber != undefined &&
      dataItem.intelReferenceNumber != null
        ? dataItem.intelReferenceNumber
        : "") +
      "</td><td><b>Doc Type</b></td><td>" +
      (dataItem.docType != undefined && dataItem.docType != null
        ? dataItem.docType
        : "") +
      "</td></tr>";
    tab_text =
      tab_text +
      "<tr><td><b>Intel Reference Line Number</b></td><td>" +
      (dataItem.intelLineReferenceNumber != undefined &&
      dataItem.intelLineReferenceNumber
        ? dataItem.intelLineReferenceNumber
        : "") +
      "</td><td></td><td></td></tr></table>";
    tab_text = tab_text + "<table><tr><td></td></tr></table>";
    tab_text =
      tab_text +
      "<table border='2px'><tr><th bgcolor='#305486' style='color:#FFFFFF'>Shipment Information</th><th></th><th></th><th rowspan='7'></th><th bgcolor='#305486' style='color:#FFFFFF'>Customs Information</th></tr>";
    tab_text =
      tab_text +
      "<tr><td rowspan='6'></td><td><b>TPT</b></td><td>" +
      (dataItem.tpt != undefined && dataItem.tpt != null ? dataItem.tpt : "") +
      "</td><td><b>Broker Contact Name</b></td><td>" +
      (dataItem.contactName != undefined && dataItem.contactName != null
        ? dataItem.contactName
        : "") +
      "</td></tr>";
    tab_text =
      tab_text +
      "<tr><td><b>Transportation Mode</b></td><td>" +
      (dataItem.transportationMode != undefined &&
      dataItem.transportationMode != null
        ? dataItem.transportationMode
        : "") +
      "</td><td><b>Broker Phone Number</b></td><td>" +
      (dataItem.phoneNumber != undefined && dataItem.phoneNumber != null
        ? dataItem.phoneNumber
        : "") +
      "</td></tr>";
    tab_text =
      tab_text +
      "<tr><td><b>Service Code</b></td><td>" +
      (dataItem.serviceCode != undefined && dataItem.serviceCode != null
        ? dataItem.serviceCode
        : "") +
      "</td><td><b>Broker Email Address</b></td><td>" +
      (dataItem.email != undefined && dataItem.email != null
        ? dataItem.email
        : "") +
      "</td></tr>";
    tab_text =
      tab_text +
      "<tr><td><b>Service Type/ Commodity Type</b></td><td>" +
      (dataItem.commodityType != undefined && dataItem.commmodityType != null
        ? dataItem.commodityType
        : "") +
      "</td><td><b>Special Instructions</b></td><td>" +
      (dataItem.specialInstructions != undefined &&
      dataItem.specialInstructions != null
        ? dataItem.specialInstructions
        : "") +
      "</td></tr>";
    tab_text =
      tab_text +
      "<tr><td><b>Incoterms</b></td><td>" +
      (dataItem.incoterms != undefined && dataItem.incoterms != null
        ? dataItem.incoterms
        : "") +
      "</td><td></td><td></td></tr>";
    tab_text =
      tab_text +
      "<tr><td><b>Incoterms Location</b></td><td>" +
      (dataItem.incotermsLocation != undefined &&
      dataItem.incotermsLocation != null
        ? dataItem.incotermsLocation
        : "") +
      "</td><td></td><td></td></tr></table>";
    tab_text = tab_text + "<table><tr><td></td></tr></table>";
    tab_text = tab_text + "<table border='2px'>";
    tab_text =
      tab_text +
      "<tr><th bgcolor='#305486' style='color:#FFFFFF'>Product Details</th></tr></table>";
    tab_text =
      tab_text +
      "<table border='2px'><tr><th bgcolor='#00b0f0' style='color:#FFFFFF'>Handling Unit</th><th bgcolor='#00b0f0' style='color:#FFFFFF'>Quantity</th><th bgcolor='#00b0f0' style='color:#FFFFFF'>Height</th><th bgcolor='#00b0f0' style='color:#FFFFFF'>Length</th><th bgcolor='#00b0f0' style='color:#FFFFFF'>Width</th><th bgcolor='#00b0f0' style='color:#FFFFFF'>Unit of Measure (L,H,W)</th><th bgcolor='#00b0f0' style='color:#FFFFFF'>Estimated Gross Weight</th><th bgcolor='#00b0f0' style='color:#FFFFFF'>Dimensional Weight</th><th bgcolor='#00b0f0' style='color:#FFFFFF'>Chargable Weight</th><th bgcolor='#00b0f0' style='color:#FFFFFF'>Unit of Measure (Weight)</th></tr></table>";

    // Set Product and Material Data
    for (var i = 0; i < totalProductArray.length; i++) {
      if (totalProductArray[i].rfqNum == dataItem.rfqNum) {
        var materialArrayCount = 0;

        tab_text =
          tab_text +
          "<table border='2px'><tr><td><b>" +
          (totalProductArray[i].PACKAGEDESCRIPTION != undefined &&
          totalProductArray[i].PACKAGEDESCRIPTION != null
            ? totalProductArray[i].PACKAGEDESCRIPTION
            : "") +
          "</b></td><td><b>" +
          (totalProductArray[i].QUA_PCS_VAL != undefined &&
          totalProductArray[i].QUA_PCS_VAL != null
            ? totalProductArray[i].QUA_PCS_VAL
            : "") +
          "</b></td><td><b>" +
          (totalProductArray[i].HEIGHT != undefined &&
          totalProductArray[i].HEIGHT != null
            ? totalProductArray[i].HEIGHT
            : "") +
          "</b></td><td><b>" +
          (totalProductArray[i].LENGTH != undefined &&
          totalProductArray[i].LENGTH != null
            ? totalProductArray[i].LENGTH
            : "") +
          "</b></td><td><b>" +
          (totalProductArray[i].WIDTH != undefined &&
          totalProductArray[i].WIDTH != null
            ? totalProductArray[i].WIDTH
            : "") +
          "</b></td><td><b>" +
          (totalProductArray[i].MEASUOM != undefined &&
          totalProductArray[i].MEASUOM != null
            ? totalProductArray[i].MEASUOM
            : "") +
          "</b></td><td><b>" +
          (totalProductArray[i].GRO_WEI_VAL != undefined &&
          totalProductArray[i].GRO_WEI_VAL != null
            ? totalProductArray[i].GRO_WEI_VAL
            : "") +
          "</b></td><td><b>" +
          (totalProductArray[i].DIM_WEI_VAL != undefined &&
          totalProductArray[i].DIM_WEI_VAL != null
            ? totalProductArray[i].DIM_WEI_VAL
            : "") +
          "</b></td><td><b>" +
          (totalProductArray[i].chargableWeight != undefined &&
          totalProductArray[i].chargableWeight != null
            ? totalProductArray[i].chargableWeight
            : "") +
          "</b></td><td><b>" +
          (totalProductArray[i].GRO_WEI_UNI != undefined &&
          totalProductArray[i].GRO_WEI_UNI != null
            ? totalProductArray[i].GRO_WEI_UNI
            : "") +
          "</b></td></tr></table>";

        var materialArraylength = 0;

        for (var j = 0; j < totalMaterialArray.length; j++) {
          if (
            totalMaterialArray[j].ITEM_PARENT_KEY == totalProductArray[i].DB_KEY
          ) {
            materialArraylength = materialArraylength + 1;
          }
        }
        materialArraylength = materialArraylength + 1;

        for (var j = 0; j < totalMaterialArray.length; j++) {
          if (
            totalMaterialArray[j].ITEM_PARENT_KEY == totalProductArray[i].DB_KEY
          ) {
            if (materialArrayCount == 0) {
              materialArrayCount = materialArrayCount + 1;

              tab_text =
                tab_text +
                "<table border='2px'><tr><th rowspan='" +
                materialArraylength +
                "'></th><th bgcolor='#00b0f0' style='color:#FFFFFF'>Material ID</th><th bgcolor='#00b0f0' style='color:#FFFFFF'>Material Description</th><th bgcolor='#00b0f0' style='color:#FFFFFF'>Material Value</th><th bgcolor='#00b0f0' style='color:#FFFFFF'>Currency</th></tr>";
            }

            tab_text =
              tab_text +
              "<tr><td>" +
              (totalMaterialArray[j].PRODUCT_ID != undefined &&
              totalMaterialArray[j].PRODUCT_ID != null
                ? totalMaterialArray[j].PRODUCT_ID
                : "") +
              "</td><td>" +
              (totalMaterialArray[j].ITEM_DESCR != undefined &&
              totalMaterialArray[j].ITEM_DESCR != null
                ? totalMaterialArray[j].ITEM_DESCR
                : "") +
              "</td><td>" +
              (totalMaterialArray[j].AMT_GDSV_VAL != undefined &&
              totalMaterialArray[j].AMT_GDSV_VAL != null
                ? totalMaterialArray[j].AMT_GDSV_VAL
                : "") +
              "</td><td>" +
              (totalMaterialArray[j].AMT_GDSV_CUR != undefined &&
              totalMaterialArray[j].AMT_GDSV_CUR != null
                ? totalMaterialArray[j].AMT_GDSV_CUR
                : "") +
              "</td></tr>";

            if (j == totalMaterialArray.length)
              tab_text = tab_text + "</table>";
          }
        }
      }
    }
    tab_text = tab_text + "</table>";
    tab_text = tab_text + "<table><tr><td></td></tr></table>";
    tab_text =
      tab_text +
      "<table><tr><td></td><td></td><td bgcolor='#ffff00' border='2px'>Total Chargable Weight</td><td bgcolor='#ffff00' border='2px'>" +
      weightValue +
      "</td></tr></table>";
    tab_text = tab_text + "<table><tr><td></td></tr></table>";
    tab_text = tab_text + "<table border='2px'>";
    tab_text =
      tab_text +
      "<tr><th bgcolor='#305486' style='color:#FFFFFF'>Quotation Details</th></tr></table>";
    tab_text =
      tab_text +
      "<table border='2px'><th bgcolor='#00b0f0' style='color:#FFFFFF'>Quotation Number</th><th bgcolor='#00b0f0' style='color:#FFFFFF'>Status</th><th bgcolor='#00b0f0' style='color:#FFFFFF'>Response Code</th><th bgcolor='#00b0f0' style='color:#FFFFFF'>Price Proposal</th><th bgcolor='#00b0f0' style='color:#FFFFFF'>Price Proposal Currency</th><th bgcolor='#00b0f0' style='color:#FFFFFF'>Pick-up Date</th><th bgcolor='#00b0f0' style='color:#FFFFFF'>Delivery Date</th><th bgcolor='#00b0f0' style='color:#FFFFFF'>Comments</th></tr>";

    for (var i = 0; i < quotationArray.length; i++) {
      tab_text =
        tab_text +
        "<tr><td>" +
        (quotationArray[i].quoteNum != undefined &&
        quotationArray[i].quoteNum != null
          ? quotationArray[i].quoteNum
          : "") +
        "</td><td>" +
        (quotationArray[i].quoteStatDesc != undefined &&
        quotationArray[i].quoteStatDesc != null
          ? quotationArray[i].quoteStatDesc
          : "") +
        "</td><td>" +
        (quotationArray[i].awardStatDesc != undefined &&
        quotationArray[i].awardStatDesc != null
          ? quotationArray[i].awardStatDesc
          : "") +
        "</td><td>" +
        (quotationArray[i].submittedPrice != undefined &&
        quotationArray[i].submittedPrice != null
          ? quotationArray[i].submittedPrice
          : "") +
        "</td><td>" +
        (quotationArray[i].submittedCurrency != undefined &&
        quotationArray[i].submittedCurrency != null
          ? quotationArray[i].submittedCurrency
          : "") +
        "</td><td>" +
        (quotationArray[i].sourceDateTimestamp != undefined &&
        quotationArray[i].sourceDateTimestamp != null
          ? quotationArray[i].sourceDateTimestamp
          : "") +
        "</td><td>" +
        (quotationArray[i].destDateTimestamp != undefined &&
        quotationArray[i].destDateTimestamp != null
          ? quotationArray[i].destDateTimestamp
          : "") +
        "</td><td>" +
        (quotationArray[i].comments != undefined &&
        quotationArray[i].comments != null
          ? quotationArray[i].comments
          : "") +
        "</td></tr>";
    }

    tab_text = tab_text + "</table>";
    tab_text = tab_text.replace(/<A[^>]*>|<\/A>/g, "");
    tab_text = tab_text.replace(/<img[^>]*>/gi, "");
    tab_text = tab_text.replace(/<input[^>]*>|<\/input>/gi, "");

    // var ua = window.navigator.userAgent;
    // var msie = ua.indexOf("MSIE ");
    // var regex = /Trident.*rv\:11\./;

    // if (msie > 0 || !!navigator.userAgent.match(regex)) // If Internet Explorer
    // {
    //     $('txtArea1').document.open("txt/html", "replace");
    //     $('txtArea1').document.write(tab_text);
    //     $('txtArea1').document.close();
    //     //sa = txtArea1.document.execCommand("SaveAs", true, "Routing_Guide_Query_Results.xls"); -- Commented out 09-Apr-2019
    //     // File Name Change Starts - 09-Apr-2019
    //     if($.isDefined(dataItem.rfqNum) && dataItem.rfqNum != null) {
    //         var name = "RFQ-" + dataItem.rfqNum + ".xls";
    //         sa = $('txtArea1').document.execCommand("SaveAs", true, name);
    //     }
    //     else {
    //         sa = $('txtArea1').document.execCommand("SaveAs", true, "RFQ.xls");
    //     }
    //     // File Name Change Ends - 09-Apr-2019
    // }
    // else //other browser not tested on IE 11
    // {
    // var sa = window.open(
    //   "data:application/vnd.ms-excel," + encodeURIComponent(tab_text)
    // );
    //  }

   
    
   
        
   this.exportTableToExcel(encodeURIComponent(tab_text))
      
    
  }

  exportTableToExcel(tableData){
    var downloadLink;
    var dataType = 'application/vnd.ms-excel';
    
    var tableHTML = tableData
    
    // Specify file name
  var  filename = 'RFQ.xls';
    
    // Create download link element
    downloadLink = document.createElement("a");
    
    document.body.appendChild(downloadLink);
    
    if(navigator.msSaveOrOpenBlob){
        var blob = new Blob(['\ufeff', tableHTML], {
            type: dataType
        });
        navigator.msSaveOrOpenBlob( blob, filename);
    }else{
        // Create a link to the file
        downloadLink.href = 'data:' + dataType + ', ' + tableHTML;
    
        // Setting the file name
        downloadLink.download = filename;
        
        //triggering the function
        downloadLink.click();
    }
}

  cancelDialog() {
    $("#myModal").hide();
  }

  rejectConfirm() {
    $("#myModal").hide();
    this.setState({ blocking: true });
    var selectedRejectedReasonCode = "";
    if (this.state.rejectReasonCodeValue.text == "Select Reason") {
      selectedRejectedReasonCode = "";
    } else {
      selectedRejectedReasonCode = this.state.rejectReasonCodeValue.value;
      var rejectedObj = {};
      rejectedObj["rfqNum"] = this.state.rfqNum;
      rejectedObj["respType"] = "Rejected";
      rejectedObj["rejReason"] = selectedRejectedReasonCode;
      rejectedObj["sourceDatetime"] = null;
      rejectedObj["destDatetime"] = null;
      rejectedObj["totalPrice"] = null;
      rejectedObj["respCurrency"] = null;
      rejectedObj["Comments"] = this.state.rejectComments;
      // getTMData.callGatewayService("Q_CREATE_QUOTATION", rejectedObj).then(onRejectRFQSuccess, onRejectRFQFailure);
      this.rejectRFQCall(rejectedObj);
      //Need to do the success part
    }
  }

  async rejectRFQCall(input) {
    let props = {};
    let inputObj = {};

    let InputJSONString = JSON.stringify(input);
    props["query"] = constants.serviceRoot;
    props["headers"] = constants.serviceHeaders;
    inputObj["Activity"] = "Q_CREATE_QUOTATION";
    inputObj["Input"] = InputJSONString;
    props.input = inputObj;

    const result = await GatewayGet(props, props.input);
    this.setState({ blocking: false });
  }

  async getRejectReasonCode() {
    let props = {};
    let inputObj = {};
    let dropdownObj = {};
    dropdownObj["Input"] = "";
    let InputJSONString = JSON.stringify(dropdownObj);
    props["query"] = constants.serviceRoot;
    props["headers"] = constants.serviceHeaders;
    inputObj["Activity"] = "F4_REJ_REASON_CODE";
    inputObj["Input"] = InputJSONString;
    props.input = inputObj;

    const result = await GatewayGet(props, props.input);
    this.setState({ rejectedReasonCode: result });
  }

  async getDocumentType() {
    ;
    let props = {};
    let inputObj = {};
    let dropdownObj = {};
    dropdownObj["Input"] = "";
    let InputJSONString = JSON.stringify(dropdownObj);
    props["query"] = constants.serviceRoot;
    props["headers"] = constants.serviceHeaders;
    inputObj["Activity"] = "F4_DOCUMENT_TYPE";
    inputObj["Input"] = InputJSONString;
    props.input = inputObj;

    const result = await GatewayGet(props, props.input);
    this.setState({ documentTypeArr: result });
  }

  handleReasonCodeChange = (e) => {
    this.setState({ rejectReasonCodeValue: e.target.value });
  };

  handleRejectComments = (e) => {
    // this.setState({rejectComments : e.value});
    this.state.rejectComments = e.target.value;
  };

  async componentDidMount() {
    this.setState({ blocking: true });
    $("#myModal").hide();
    this.getServiceCode();
    this.getServiceType();
    this.getTransportationMode();
    this.getRejectReasonCode();
    this.getDocumentType();


    const reqData = this.props.data;

    var reqInput = {};
    reqInput["tor_id"] = this.props.data.foNum;
    this.getRequestDetails(reqInput);

    var rfqInput = {};
    rfqInput["rfqNum"] = this.props.data.rfqNum;
    this.getQuotationDetails(rfqInput);
    this.state.rfqNum = this.props.data.rfqNum;

    //to enable / disable buttons.

    this.setState({
      showCreateQuotation: false,
      showCopyQuotation: false,
      showRejectRFQ: false,
      showViewQuotation: false,
      showCreateInvoice: false,
      showViewInvoice: false,
      showEditInvoice: false,
    });

    if (
      (this.props.data.tendDocStatus == "35" ||
        this.props.data.tendDocStatus == "80") &&
      this.props.data.rfqStatus == "02" &&
      this.props.data.tendRespCuststatus == "" &&
      this.props.data.tendRespAwardstatus == ""
    ) {
      this.setState({ showCreateQuotation: true, showRejectRFQ: true });
    }
    if (
      (this.props.data.tendDocStatus == "35" ||
        this.props.data.tendDocStatus == "60" ||
        this.props.data.tendDocStatus == "80") &&
      this.props.data.rfqStatus == "02" &&
      this.props.data.tendRespCuststatus == "" &&
      this.props.data.tendRespAwardstatus == "PE"
    ) {
      this.setState({
        showCreateQuotation: true,
        showCopyQuotation: true,
        showRejectRFQ: true,
      });
    }
    //Need to tweek here to enable createInvoice button
    if (
      this.props.data.tendDocStatus == "70" &&
      this.props.data.rfqStatus == "03" &&
      this.props.data.tendRespAwardstatus == "AW"
    ) {
      this.setState({ showCreateInvoice: true });
    }
    if (
      (this.props.data.tendDocStatus == "90" &&
        this.props.data.rfqStatus == "03" &&
        this.props.data.tendRespAwardstatus == "AW") ||
      this.props.data.tendDocStatus == "77"
    ) {
      this.setState({ showViewInvoice: true });
    }

    if (this.props.data.tendDocStatus == "73") {
      this.setState({ showEditInvoice: true });
    }
    if (
      this.props.data.tendDocStatus == "55" ||
      this.props.data.tendDocStatus == "99"
    ) {
      this.setState({
        showCreateQuotation: false,
        showCopyQuotation: false,
        showRejectRFQ: false,
        showViewQuotation: true,
        showCreateInvoice: false,
        showViewInvoice: false,
      });
    }
  }

  render() {
    return (
      <div className="RFQ">
        {/* <section style={{ width = "", float: "left" }}> */}
        <BlockUi
          tag="div"
          blocking={this.state.blocking}
          loader={
            <Circles
                  color="#00BFFF"
                  height="100"
                  width="100"
                  timeout="6000" //3 secs
                />
          }
        >
          <MDBContainer fluid>
            <MDBRow>
              <MDBCol>
                <p className="rqtitle">
                  RFQ Details
                </p>
                <br></br>
              </MDBCol>
            </MDBRow>
            <MDBRow>
              <MDBCol md="1"></MDBCol>

              <MDBCol md="2">
                <label className="reqDetails">Tendering Manager</label>
              </MDBCol>
              <MDBCol md="3">
                <input
                  type="text"
                  disabled={true}
                  style={{ width: "300px" }}
                  value={this.state.tendmgr}
                ></input>
              </MDBCol>

              <MDBCol md="2" className="md-2">
                <label className="reqDetails">Currency</label>
              </MDBCol>
              <MDBCol md="2">
                <input
                  type="text"
                  disabled={true}
                  value={this.state.currency}
                ></input>
              </MDBCol>
            </MDBRow>
            <br></br>
            <MDBRow>
              <MDBCol md="1"></MDBCol>

              <MDBCol md="2">
                <label className="reqDetails">
                  Intel Reference Number(PO,ISM,DN)
                </label>
              </MDBCol>
              <MDBCol md="3">
                <textarea
                  className="intel_reqTextarea"
                  disabled={true}
                  value={this.state.IntelRefNo}
                ></textarea>
              </MDBCol>

              <MDBCol md="2" className="md-2">
                <label className="reqDetails">Doc Type</label>
              </MDBCol>
              <MDBCol md="2">
                <input
                  type="text"
                  disabled={true}
                  value={this.state.docType}
                ></input>
              </MDBCol>
            </MDBRow>
            <br></br>
            <MDBRow>
              <MDBCol>
              <p className="rqtitle">Shipment Information</p>
              <br></br>
              </MDBCol>
              <MDBCol>
              <p className="rqtitle">Customer Information</p>
              <br></br>
                
              </MDBCol>
            </MDBRow>
            <MDBRow>
              <MDBCol md="1"></MDBCol>

              <MDBCol md="2">
                <label className="reqDetails">TPT</label>
              </MDBCol>
              <MDBCol md="3">
                <input
                  style={{ width: "300px" }}
                  disabled={true}
                  value={this.state.tpt}
                ></input>
              </MDBCol>

              <MDBCol md="2" className="md-2">
                <label className="reqDetails">Broker Contact Name</label>
              </MDBCol>
              <MDBCol md="2">
                <input
                  type="text"
                  disabled={true}
                  value={this.state.brokerName}
                ></input>
              </MDBCol>
            </MDBRow>
            <br></br>
            <MDBRow>
              <MDBCol md="1"></MDBCol>

              <MDBCol md="2">
                <label className="reqDetails">Transportation Mode</label>
              </MDBCol>
              <MDBCol md="3">
                <input
                  style={{ width: "300px" }}
                  disabled={true}
                  value={this.state.transMode}
                ></input>
              </MDBCol>

              <MDBCol md="2" className="md-2">
                <label className="reqDetails">Broker Phone Number</label>
              </MDBCol>
              <MDBCol md="2">
                <input
                  type="text"
                  disabled={true}
                  value={this.state.brokerPhoneNo}
                ></input>
              </MDBCol>
            </MDBRow>
            <br></br>
            <MDBRow>
              <MDBCol md="1"></MDBCol>

              <MDBCol md="2">
                <label className="reqDetails"> Service Code</label>
              </MDBCol>
              <MDBCol md="3">
                <input
                  style={{ width: "300px" }}
                  disabled={true}
                  value={this.state.srvCode}
                ></input>
              </MDBCol>

              <MDBCol md="2" className="md-2">
                <label className="reqDetails">Broker Email Address</label>
              </MDBCol>
              <MDBCol md="2">
                <input
                  type="text"
                  disabled={true}
                  value={this.state.brokerEmail}
                ></input>
              </MDBCol>
            </MDBRow>
            <br></br>
            <MDBRow>
              <MDBCol md="1"></MDBCol>

              <MDBCol md="2">
                <label className="reqDetails">
                  Service Type/Commodity Type
                </label>
              </MDBCol>
              <MDBCol md="3">
                <input
                  style={{ width: "300px" }}
                  disabled={true}
                  value={this.state.commType}
                ></input>
              </MDBCol>

              <MDBCol md="2" className="md-2">
                <label className="reqDetails">Special Instruction</label>
              </MDBCol>
              <MDBCol md="2">
                <textarea
                  type="text"
                  className="reqTextarea"
                  disabled={true}
                  value={this.state.specialInst}
                ></textarea>
              </MDBCol>
            </MDBRow>
            <br></br>
            <MDBRow>
              <MDBCol md="1"></MDBCol>

              <MDBCol md="2">
                <label className="reqDetails">Incoterms</label>
              </MDBCol>
              <MDBCol md="3">
                <input
                  style={{ width: "300px" }}
                  disabled={true}
                  value={this.state.Incoterms}
                ></input>
              </MDBCol>

              <MDBCol md="2" className="md-2"></MDBCol>
              <MDBCol md="2"></MDBCol>
            </MDBRow>
            <br></br>
            <MDBRow>
              <MDBCol md="1"></MDBCol>

              <MDBCol md="2">
                <label className="reqDetails">Incoterms Location</label>
              </MDBCol>
              <MDBCol md="3">
                <input
                  style={{ width: "300px" }}
                  disabled={true}
                  value={this.state.IncoLoc}
                ></input>
              </MDBCol>

              <MDBCol md="2" className="md-2"></MDBCol>
              <MDBCol md="2"></MDBCol>
            </MDBRow>
          </MDBContainer>
          <MDBContainer fluid>
            <MDBRow>
              <div>
                <p className="rqtitle">Product Details</p>
                  <br></br>
              </div>
            </MDBRow>
            <MDBRow>
              {this.state.itemData != undefined && (
                <RFQMaterialGrid
                  itemData={this.state.itemData}
                ></RFQMaterialGrid>
              )}
            </MDBRow>
          </MDBContainer>
          <br></br>
          <br></br>
          <MDBContainer fluid>
            <MDBRow>
              {/*  */}
              <MDBCol className="flxinline">
                
                <button
                  disabled={!this.state.showCreateQuotation}
                  className="btn k-button k-button-icontext"
                  
                  onClick={() =>
                    this.props.onAcceptNcreateQuotationClicked({
                      ReqPickupDate: this.state.ReqPickupDate,
                      ReqDeliveryDate: this.state.ReqDeliveryDate,
                      tor_id: this.props.data.foNum,
                      rfq_no: this.state?.rfqNum,
                      rfq_multibid_currency: this.state?.rfq_multibid_currency,
                      buttonType: "create Quotation",
                       
                      timeFromZone: this.state.ShipFromTimeZone,
                      timeToZone: this.state.ShipToTimeZone,
                    })
                  }
                >
                  Accept and Create Quotation
                </button>
              <button
                  disabled={!this.state.showCopyQuotation}
                  className="btn k-button k-button-icontext"
                  
                  onClick={this.copyQuotation.bind(this)}
                >
                  Copy And Create Quotation
                </button>
              
                <button
                  disabled={!this.state.showRejectRFQ}
                  onClick={this.rejectRFQ.bind(this)}
                  className="btn k-button k-button-icontext"
                  
                >
                  Reject RFQ
                </button>
              
                <button
                  disabled={!this.state.QuotationAvailable}
                  className="btn k-button k-button-icontext"
                  
                  onClick={() =>
                    this.props.onAcceptNcreateQuotationClicked({
                      ReqPickupDate: this.state.ReqPickupDate,
                      ReqDeliveryDate: this.state.ReqDeliveryDate,
                      tor_id: this.props.data.foNum,
                      rfq_no: this.state?.rfqNum,
                      rfq_multibid_currency: this.state?.rfq_multibid_currency,
                      quotationNum: this.state.selectedQuoteData?.quoteNum ? Number(this.state.selectedQuoteData?.quoteNum) : -1,
                      buttonType: "view Quotation",
                       
                      timeFromZone: this.state.ShipFromTimeZone,
                      timeToZone: this.state.ShipToTimeZone,
                    })
                  }
                >
                  View Quotation
                </button>
              
                <button
                  disabled={!this.state.showCreateInvoice}
                  onClick={this.createInvoice.bind(this)}
                  className="btn k-button k-button-icontext"
                  
                >
                  Create Invoice
                </button>
              
                <button
                  disabled={!this.state.showEditInvoice}
                  onClick={this.editInvoice.bind(this)}
                  className="btn k-button k-button-icontext"
                  
                >
                  Edit Invoice
                </button>
              
                <button
                  disabled={!this.state.showViewInvoice}
                  onClick={this.viewInvoice.bind(this)}
                  className="btn k-button k-button-icontext"
                  
                >
                  View Invoice{" "}
                </button>
                              <button
                  className="btn k-button k-button-icontext"
                  onClick={this.exportToExcel.bind(this)}
                >
                  Export
                </button>
              </MDBCol>
            </MDBRow>
          </MDBContainer>
          <br></br>
          <MDBContainer fluid>
          {this.state.quotationData.length > 0 && (
            <MDBRow>
              <div>
                <p className="rqtitle">
                  Quotation Details
                </p>
                <br></br>
              </div>
            </MDBRow>)}
            <MDBRow>
              {this.state.quotationData.length > 0 && (
                <RFQQuotationGrid
                  quoteData={this.state.quotationData}
                  getSelectedQuotation={this.getQuotationData}
                ></RFQQuotationGrid>
              )}
            </MDBRow>
          </MDBContainer>
          {/* </section> */}

          <div className="modals" id="myModal">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="headerTitle">Confirm Reject Quotation</h5>
                <button
                  type="button"
                  className="close"
                  onClick={this.cancelDialog}
                >
                  &times;
                </button>
              </div>
              <div className="modal-body">
                <form className="k-form">
                  <fieldset>
                    <legend></legend>

                    <MDBContainer>
                      <MDBRow>
                        <MDBCol md="2">
                          <label>Reason </label>
                        </MDBCol>
                        <MDBCol>
                          <DropDownList
                            data={this.state.rejectedReasonCode}
                            defaultItem={{ text: "Select Reason" }}
                            dataItemKey="value"
                            textField="text"
                            value={this.state.rejectReasonCodeValue}
                            onChange={this.handleReasonCodeChange.bind(this)}
                          ></DropDownList>
                        </MDBCol>
                      </MDBRow>
                      <MDBRow>
                        <MDBCol md="2">
                          <label>Comments</label>
                        </MDBCol>
                        <MDBCol>
                          <input
                            type="text"
                            value={this.state.rejectComments}
                            onChange={this.handleRejectComments.bind(this)}
                          ></input>
                        </MDBCol>
                      </MDBRow>
                    </MDBContainer>
                  </fieldset>
                </form>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn k-button k-button-icontext"
                  onClick={this.rejectConfirm.bind(this)}
                >
                  ok
                </button>
                <button
                  type="button"
                  className="btn k-button k-button-icontext"
                  onClick={this.cancelDialog}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </BlockUi>
        <iframe id="txtArea1" style={{ display: "none" }}></iframe>
      </div>
    );
  }
}

export default RFQRequestDetails;
